import i18n from '@/providers/i18n'

//user
export const users = {
  id: 'users:fields.id',
  username: 'users:fields.username',
  userfname: 'users:fields.userfname',
  userlname: 'users:fields.userlname',
  email: {
    trans: 'users:fields.email',
    inputType: 'email',
  },
  active: {
    trans: 'users:fields.active',
  },
  pnumber: 'users:fields.pnumber',
  bday: {
    trans: 'users:fields.bday',
    type: 'date',
  },
  created_at: {
    trans: 'users:fields.created_at',
    type: 'datetime',
  },
  gender: {
    trans: 'users:fields.gender',
  },
  address: 'users:fields.address',
  vat: 'users:fields.vat',
  zip: 'users:fields.zip',
  state: 'users:fields.state',
  city: 'users:fields.city',
  website: 'users:fields.website',
  countries_id: {
    trans: 'users:fields.country',
    type: 'resource',
    resource: 'countries',
  },
  company_name: 'users:fields.company_name',
  company_contact_email: 'users:fields.company_contact_email',
  company_vat: 'users:fields.company_vat',
}

//logins
export const users_logins = {
  created_at: {
    trans: 'users:login_date',
    type: 'datetime',
  },
  successful: {
    trans: 'users:login_status',
    function: login => i18n.i18next.t('users:login_' + (login.successful ? 'ok' : 'fail'))
  },
}

//segmentation
export const users_segmentations = {
  title: {
    trans: 'users:segments.fields.title',
    required: true,
  },
  age_gap: {
    trans: 'users:segments.fields.age',
    type: 'fancySelect',
    values: {
      all: 'users:segments.fields.all_ages',
      '0-18': '0-18',
      '18-24': '18-24',
      '25-34': '25-34',
      '35-44': '35-44',
      '45-54': '45-54',
      '55-64': '55-64',
      '65-110': '65+',
    },
    required: false,
  },
  age_gap_from: {
    trans: 'users:segments.fields.age',
    type: 'int',
    min: 0,
  },
  age_gap_to: {
    label: unescape('%u00A0'), //nbsp;
    type: 'int',
    min: 0,
  },
  interests: 'users:segments.fields.interests',
  description: {
    trans: 'users:segments.fields.desc',
    type: 'textarea',
  },
  //likes: 'users:segments.fields.likes',
  gender: {
    trans: 'users:segments.fields.gender',
    type: 'selectMulti',
    values: {
      m: 'users:segments.fields.male',
      f: 'users:segments.fields.female',
      o: 'users:segments.fields.other',
    },
  },
  countries_id: {
    trans: 'users:segments.fields.countries',
    type: 'resourceMulti',
    resource: 'countries',
  },
  tags: {
    trans: 'users:segments.fields.interests',
    type: 'tags',
    required: false,
  }
}



// WEBPACK FOOTER //
// ./src/sections/users/fieldstwo.js